import React, { useEffect, useState } from 'react';
import { TextField, Button, Box, DialogActions, DialogContent, DialogTitle
  , useMediaQuery, Dialog, Snackbar, Typography } from '@mui/material';
import { NumericFormat } from "react-number-format";
import { useTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useSaveCorporateKPIMutation } from '../../services/home';
import moment from 'moment';

export default function CorporateKPIInput({open, setOpen, record, getData, selectedDate, getCorporateKPI}) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
	const [saveCorporateKPI, saveCorporateKPIResult] = useSaveCorporateKPIMutation();
	const [item, setItem] = useState({});
  const [alert, setAlert] = useState(false);
  const [dateTarget, setDateTarget] = useState(moment(selectedDate).startOf('month'));

  useEffect(() => {
    setDateTarget(moment(selectedDate).startOf('month'));
	}, [selectedDate, open]);

  useEffect(() => {
		setItem(record);
	}, [record]);

  const handleClose = () => {
    setOpen(false);
  };

	const onSave = async() =>{
    if(open == "Finance"){
      await saveFinance();
      return;
    }
    if(open == "HR"){
      await saveHR();
      return;
    }
    try {
      let error = false;
      let data = {department: open, fromdate: moment(dateTarget).format("01/MM/YYYY")};
      // if(open == "Logistics") data.fromdate = moment(dateTarget).format("01/MM/YYYY");

      if(item.target){
        data = {...data, field: "target", value: item.target};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.actual){
        data = {...data, field: "actual", value: item.actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      
      if(error)
        setAlert(error);
      else{
        setAlert("Saved!");
        getData();
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
	}

  const saveFinance=async()=>{
    try {
      let error = false;
      let data = {department: open, fromdate: moment(dateTarget).format("01/MM/YYYY")};
      if(item.budget_ytd){
        data = {...data, name: 'ebit', field: "budget_ytd", value: item.budget_ytd};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.budget_ytg){
        data = {...data, name: 'ebit', field: "budget_ytg", value: item.budget_ytg};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.actual_ytd){
        data = {...data, name: 'ebit', field: "actual_ytd", value: item.actual_ytd};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.actual_ytg){
        data = {...data, name: 'ebit', field: "actual_ytg", value: item.actual_ytg};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.cost_actual){
        data = {...data, name: 'cost', field: "cost_actual", value: item.cost_actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.last_month){
        data = {...data, name: 'cost', field: "last_month", value: item.last_month};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      
      if(error)
        setAlert(error);
      else{
        setAlert("Saved!");
        getData();
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
  }

  const saveHR=async()=>{
    try {
      let error = false;
      let data = {department: open, fromdate: moment(dateTarget).format("01/MM/YYYY")};
      if(item.ave_actual){
        data = {...data, name: 'Ave FTE/Store', field: "ave_actual", value: item.ave_actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.ave_target){
        data = {...data, name: 'Ave FTE/Store', field: "ave_target", value: item.ave_target};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.d2c_actual){
        data = {...data, name: 'cost', field: "d2c_actual", value: item.d2c_actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.d2c_target){
        data = {...data, name: 'cost', field: "d2c_target", value: item.d2c_target};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.ecom_actual){
        data = {...data, name: 'cost', field: "ecom_actual", value: item.ecom_actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.ecom_target){
        data = {...data, name: 'cost', field: "ecom_target", value: item.ecom_target};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.b2b_actual){
        data = {...data, name: 'cost', field: "b2b_actual", value: item.b2b_actual};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      if(item.b2b_target){
        data = {...data, name: 'cost', field: "b2b_target", value: item.b2b_target};
        const result = await saveCorporateKPI(data).unwrap();
        const dt = JSON.parse(result);
        if(dt[0].ERROR) error = dt[0].ERROR;
      }
      
      if(error)
        setAlert(error);
      else{
        setAlert("Saved!");
        getData();
        setOpen(false);
      }
    } catch (err) {
      setAlert("Lỗi kết nối!");
      console.error(err);
    }
  }

  const onChangeDateTarget=()=>{
		getCorporateKPI({type: 'detailCorporateKPI', department: open, fromdate: moment(dateTarget).format('DD/MM/YYYY')});
	}

  return (
    <React.Fragment>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" sx={{textAlign: 'center', fontWeight: 600}}>
          {open}
        </DialogTitle>
				{/* <Divider /> */}
        <DialogContent>
          {open == "Finance"?
          <>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Typography variant="h7" fontWeight="700" sx={{width: '46px'}}>
                EBIT To NS
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
                  <Typography fontWeight="700" sx={{width: .14, color: 'blue'}}>
                    NS{/* Budget */}
                  </Typography>
                  <NumericFormat sx={{width: .43}}
                    value={item.budget_ytd||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, budget_ytd: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Actual"// label="YTD"
                    fullWidth={true}
                  />
                  <NumericFormat sx={{width: .43}}
                    value={item.budget_ytg||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, budget_ytg: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="LFC"// label="YTG"
                    fullWidth={true}
                  />
                </Box>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
                  <Typography fontWeight="700" sx={{width: .14, color: 'blue'}}>
                    EBIT{/* Actual */}
                  </Typography>
                  <NumericFormat sx={{width: .43}}
                    value={item.actual_ytd||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, actual_ytd: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Actual"// label="YTD"
                    fullWidth={true}
                  />
                  <NumericFormat sx={{width: .43}}
                    value={item.actual_ytg||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, actual_ytg: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="LFC"// label="YTG"
                    fullWidth={true}
                  />
                </Box>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
              <Typography variant="h7" fontWeight="700" sx={{width: .256}}>
                Cost NPC and A&P
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <NumericFormat sx={{width: .5}}
                  value={item.cost_actual||0}
                  customInput={TextField}
                  onValueChange={(e)=>setItem({...item, cost_actual: e.floatValue||0})}
                  thousandSeparator={true}
                  decimalSeparator="."
                  label="Actual"
                  fullWidth={true}
                />
                <NumericFormat sx={{width: .5}}
                  value={item.last_month||0}
                  customInput={TextField}
                  onValueChange={(e)=>setItem({...item, last_month: e.floatValue||0})}
                  thousandSeparator={true}
                  decimalSeparator="."
                  label="Last month FC"
                  fullWidth={true}
                />
              </Box>
            </Box>
          </>
      :open == "HR"?
          <>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Typography variant="h7" fontWeight="700" sx={{width: .272}}>
                Ave FTE/Store
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
                <NumericFormat
                  value={item.ave_actual||0}
                  customInput={TextField}
                  onValueChange={(e)=>setItem({...item, ave_actual: e.floatValue||0})}
                  thousandSeparator={true}
                  decimalSeparator="."
                  label="Actual"
                  fullWidth={true}
                />
                <NumericFormat
                  value={item.ave_target||0}
                  customInput={TextField}
                  onValueChange={(e)=>setItem({...item, ave_target: e.floatValue||0})}
                  thousandSeparator={true}
                  decimalSeparator="."
                  label="Target"
                  fullWidth={true}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Typography variant="h7" fontWeight="700">
                PC Cost
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0, alignItems: 'center' }}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
                  <Typography fontWeight="700" sx={{width: .14}}>
                    D2C
                  </Typography>
                  <NumericFormat sx={{width: .43}}
                    value={item.d2c_actual||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, d2c_actual: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Actual"
                    fullWidth={true}
                  />
                  <NumericFormat sx={{width: .43}}
                    value={item.d2c_target||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, d2c_target: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Target"
                    fullWidth={true}
                  />
                </Box>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
                  <Typography fontWeight="700" sx={{width: .14}}>
                    ECOM
                  </Typography>
                  <NumericFormat sx={{width: .43}}
                    value={item.ecom_actual||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, ecom_actual: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Actual"
                    fullWidth={true}
                  />
                  <NumericFormat sx={{width: .43}}
                    value={item.ecom_target||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, ecom_target: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Target"
                    fullWidth={true}
                  />
                </Box>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 2 }}>
                  <Typography fontWeight="700" sx={{width: .14}}>
                    B2B
                  </Typography>
                  <NumericFormat sx={{width: .43}}
                    value={item.b2b_actual||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, b2b_actual: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Actual"
                    fullWidth={true}
                  />
                  <NumericFormat sx={{width: .43}}
                    value={item.b2b_target||0}
                    customInput={TextField}
                    onValueChange={(e)=>setItem({...item, b2b_target: e.floatValue||0})}
                    thousandSeparator={true}
                    decimalSeparator="."
                    label="Target"
                    fullWidth={true}
                  />
                </Box>
              </Box>
            </Box>
          </>
      :
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', paddingTop: '5px' }}>
            <Typography variant="h7" fontWeight="700" sx={{width: '300px'}}>
              {open == 'DP' ? 'OOS' : open == 'Training' ? 'NPS Score' : open == 'Marketing' ? 'ROAS' : 
                open == 'Procurement' ? 'Supplier Quality' : open == 'Logistics' ? 'TWSC /SU shipped' : ''}
            </Typography>
            <NumericFormat
              value={item.actual||0}
              customInput={TextField}
              onValueChange={(e)=>setItem({...item, actual: e.floatValue||0})}
              thousandSeparator={true}
              decimalSeparator="."
              label="Actual"
              fullWidth={true}
            />
            {open == 'Logistics' ? 
            <Box sx={{ float: 'right' , '& .MuiPickersInputBase-root': {width: '145px'}, '& .MuiStack-root': {paddingTop: 0} }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DemoContainer components={['DatePicker', 'DatePicker', 'DatePicker']}>
                  <DatePicker label="" views={['month', 'year']} format="MMM YYYY"
                  value={dateTarget} onChange={(value)=>setDateTarget(value)} onClose={onChangeDateTarget} />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            :<NumericFormat
              value={item.target||0}
              customInput={TextField}
              onValueChange={(e)=>setItem({...item, target: e.floatValue||0})}
              thousandSeparator={true}
              decimalSeparator="."
              label="Target"
              fullWidth={true}
            />
            }
          </Box>
        }
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            CLOSE
          </Button>
          <Button onClick={onSave} autoFocus>
            SAVE
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={alert}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={()=>setAlert(false)}
        message={alert}
        // action={action}
      />
    </React.Fragment>
  );
}